import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
    FiActivity,
    FiCheckCircle,
    FiClock,
    FiDollarSign,
    FiMoreHorizontal,
    FiUserCheck,
    FiUserPlus,
    FiUsers,
    FiUserX,
    FiTrendingUp,
    FiBriefcase
} from "react-icons/fi";

import { Container } from "react-bootstrap";

import {
    getDashboardSummary
} from "../../store/slices/profile";


const DashboardHome = () => {

    const dispatch = useDispatch();

    /* ================= AUTH PROFILE ================= */

    const { profile, user } = useSelector(
        (state) => state.auth
    );

    const profileData =
        profile?.data ||
        profile ||
        user?.data ||
        user ||
        {};

    const name = profileData?.name || "User";


    /* ================= DASHBOARD STATE ================= */

    const {
        dashboardSummary,
        loading
    } = useSelector(
        (state) => state.profile
    );


    /* ================= GET DASHBOARD DATA ================= */

    useEffect(() => {

        dispatch(getDashboardSummary());

    }, [dispatch]);


    /* ================= API DATA ================= */

    const summaryData =
        dashboardSummary?.data ||
        dashboardSummary ||
        {};


    /* ================= GREETING ================= */

    const getGreeting = () => {

        const hour = new Date().getHours();

        if (hour < 12) {
            return "Good morning";
        }

        if (hour < 17) {
            return "Good afternoon";
        }

        return "Good evening";
    };


    /* ================= ALL DASHBOARD STATS ================= */

    const stats = [

        {
            label: "Today's Registration",
            value: summaryData?.todayActivatedUsers ?? 0,
            icon: FiUserPlus,
            tone: "coral"
        },

        {
            label: "Total Users",
            value: summaryData?.totalUsers ?? 0,
            icon: FiUsers,
            tone: "mint"
        },

        {
            label: "Active Users",
            value: summaryData?.totalActiveUsers ?? 0,
            icon: FiUserCheck,
            tone: "blue"
        },

        {
            label: "Inactive Users",
            value: summaryData?.totalInactiveUsers ?? 0,
            icon: FiUserX,
            tone: "gold"
        },

        {
            label: "Auto Pool Income",
            value: summaryData?.totalAutoPoolIncome ?? 0,
            icon: FiTrendingUp,
            tone: "mint"
        },

        {
            label: "Referral Income",
            value: summaryData?.totalReferralIncome ?? 0,
            icon: FiBriefcase,
            tone: "coral"
        },

        {
            label: "Wallet Balance",
            value: summaryData?.totalWalletAmount ?? 0,
            icon: FiDollarSign,
            tone: "blue"
        },

        {
            label: "Pending Withdrawal",
            value: summaryData?.totalPendingWithdraw ?? 0,
            icon: FiClock,
            tone: "gold"
        },

        {
            label: "Total Withdrawn",
            value: summaryData?.totalWithdrawn ?? 0,
            icon: FiCheckCircle,
            tone: "mint"
        }

    ];


    return (
        <Container
            fluid
            className="gi-home-dashboard"
        >

            {/* ================= WELCOME ================= */}

            <section className="gi-welcome-banner">

                <div className="gi-welcome-content">

                    <span className="gi-eyebrow">
                        GLOBAL INAVATION
                    </span>

                    <h1>
                        {getGreeting()}, {name}!
                    </h1>

                    <p>
                        Here's an overview of your dashboard.
                    </p>

                </div>

            </section>


            {/* ================= ALL STATS ================= */}

            <section className="gi-stats-grid">

                {stats.map(
                    ({
                        label,
                        value,
                        icon: Icon,
                        tone
                    }) => (

                        <article
                            className={`gi-stat-card gi-stat-${tone}`}
                            key={label}
                        >

                            <div className="gi-stat-top">

                                <span className="gi-stat-icon">
                                    <Icon />
                                </span>

                                <button
                                    type="button"
                                    className="gi-card-more"
                                    aria-label={`More ${label} options`}
                                >
                                    <FiMoreHorizontal />
                                </button>

                            </div>


                            <span className="gi-stat-label">
                                {label}
                            </span>


                            <strong className="gi-stat-value">

                                {loading
                                    ? "..."
                                    : value
                                }

                            </strong>

                        </article>

                    )
                )}

            </section>

        </Container>
    );
};


export default DashboardHome;